const usePostMessage = () => {
    const postMessageToWindow = (connect: any) => {
      // Prepare the data to be sent via postMessage
      const data = { connect };
      // Send the message to any window or iframe (* allows any origin)
      window.parent.postMessage(data, '*');
    };
  
    return postMessageToWindow;
  };
  
  export default usePostMessage;